export const FENIX_INHERIT_COUNTRY_CODE = '__inherit_country_code__';

export const FILTER_OPERATOR_EQ = 'eq';
export const FILTER_OPERATOR_NE = 'ne';

export const composeFilterKey = (field, op) => {
    if (!field) return field;
    return op === FILTER_OPERATOR_NE ? `${field}__ne` : field;
};

export const filterObjectsToPairs = (filters = []) =>
    (filters || [])
        .filter((filter) => filter && filter.field)
        .map((filter) => ({
            key: composeFilterKey(filter.field, filter.op),
            value: filter.value,
        }));

export const replaceInheritedValueInFenixFilters = (
    filterPairs,
    countryCode
) => {
    if (!filterPairs || !countryCode) return filterPairs;

    return filterPairs.map((pair) =>
        pair.value === FENIX_INHERIT_COUNTRY_CODE
            ? { ...pair, value: countryCode }
            : pair
    );
};
